import { ListSourcedValue, Option, SourcedValue } from '../option.js';
import { pathToRoot, PropertyPathWalker, SourceType } from './PropertyPathWalker.js';
import { TypeKind } from '../types.js';
import { ModelSystemProperties } from './ModelSystemProperties.js';
import { optionIdSymbol } from '../engine-impl.js';
export class SourceUtils {
    constructor(schema) {
        this.schema = schema;
    }
    isSourceableProperty(model, path) {
        return this.get(this.getPropertyValue(model, path)).isSourceable;
    }
    isPropertyHasSources(model, path) {
        return Array.isArray(this.get(this.getPropertyValue(model, path)).sources);
    }
    isSourceProvider(propertyValue) {
        const needSource = propertyValue.property.opts.needSource;
        return needSource === true || Array.isArray(needSource) || needSource === 'specific';
    }
    isSourceProviderHasSources(model, name) {
        const sourceFromModel = ModelSystemProperties.getSourceFromModel(model, name);
        return sourceFromModel !== undefined && sourceFromModel !== null;
    }
    sourceProviderType(propertyValue) {
        const needSource = propertyValue.property.opts.needSource;
        if (needSource === true && this.schema.getType(propertyValue.property.type).kind === TypeKind.Object) {
            return SourceType.Single;
        }
        else if (needSource === true && this.schema.getType(propertyValue.property.type).kind === TypeKind.List) {
            return SourceType.ListCommon;
        }
        else if (Array.isArray(needSource) && this.schema.getType(propertyValue.property.type).kind === TypeKind.List) {
            return SourceType.ListCommonForNested;
        }
        else if (needSource === 'specific') {
            return SourceType.ListSpecific;
        }
        throw new Error(`'Can't determine type of source provider for ${pathToRoot(propertyValue)}`);
    }
    sourcesType(model, path) {
        return this.get(this.getPropertyValue(model, path)).type;
    }
    getPropertySources(model, path) {
        return this.get(this.getPropertyValue(model, path)).sources;
    }
    setSourcesToModel(model, path, sources) {
        ModelSystemProperties.addSourceToModel(model, path, sources);
    }
    static getInnerValue(value) {
        if (value instanceof SourcedValue) {
            if (Array.isArray(value.value)) {
                return value.value.map(v => SourceUtils.getModelValue(v));
            }
            else if (value.value instanceof Option) {
                return SourceUtils.getModelValue(value.value);
            }
            else if (value.value == null) {
                return null;
            }
            else {
                throw new Error('Unsupported structure');
            }
        }
        else if (value instanceof ListSourcedValue) {
            return value.value;
        }
        else if (value instanceof Option) {
            return SourceUtils.getModelValue(value);
        }
        else {
            return value;
        }
    }
    get(propertyValue) {
        return this._get(propertyValue, propertyValue.property.name);
    }
    _get(propertyValue, lookingPropertyName) {
        if (propertyValue.property.opts.needSource === true) {
            let source = propertyValue.parent ? ModelSystemProperties.getSource(propertyValue) : undefined;
            return {
                type: this.schema.getType(propertyValue.property.type).kind === TypeKind.List ? SourceType.ListCommon : SourceType.Single,
                isSourceable: true,
                sources: source ? source.getSource() : undefined
            };
        }
        else if (propertyValue.parent) {
            let parent = propertyValue.parent;
            if (parent.property.opts.needSource === true && this.schema.getType(parent.property.type).kind === TypeKind.List) {
                let source = parent.parent ? ModelSystemProperties.getSource(parent) : undefined;
                return {
                    type: SourceType.ListCommonElement,
                    isSourceable: true,
                    sources: source ? source.getSource() : undefined
                };
            }
            else if (parent.property.opts.needSource === 'specific') {
                let source = parent.parent ? ModelSystemProperties.getSource(parent)[propertyValue.property.name] : undefined;
                return {
                    type: SourceType.ListSpecific,
                    isSourceable: true,
                    sources: source ? source.getSource(propertyValue.property.name) : undefined
                };
            }
            else if (Array.isArray(parent.property.opts.needSource) && this.schema.getType(parent.property.type).kind === TypeKind.List &&
                parent.property.opts.needSource.includes(lookingPropertyName)) {
                let source = parent.parent ? ModelSystemProperties.getSource(parent) : undefined;
                return {
                    type: SourceType.ListCommonForNested,
                    isSourceable: true,
                    sources: source ? source.getSource(lookingPropertyName) : undefined
                };
            }
            else if (parent.parent) {
                parent = parent.parent;
                if (Array.isArray(parent.property.opts.needSource) && this.schema.getType(parent.property.type).kind === TypeKind.List &&
                    parent.property.opts.needSource.includes(lookingPropertyName)) {
                    let source = parent.parent ? ModelSystemProperties.getSource(parent) : undefined;
                    return {
                        type: SourceType.ListCommonForNestedElement,
                        isSourceable: true,
                        sources: source ? source.getSource(lookingPropertyName) : undefined
                    };
                }
            }
        }
        if (propertyValue.parent) {
            return this._get((propertyValue.parent), propertyValue.parent.property.name + '.' + lookingPropertyName);
        }
        return {
            type: undefined,
            isSourceable: false,
            sources: undefined
        };
    }
    getPropertyValue(model, path) {
        const walker = new PropertyPathWalker(path, this.schema, model, ModelSystemProperties.getTypeRef(model));
        return walker.getPropertyValue();
    }
    static getModelValue(v) {
        return v.model;
    }
    static setOptionId(target, id) {
        target['_id'] = id;
    }
    static setProductId(model, _id) {
        model[optionIdSymbol] = _id;
    }
    getListCommonForNestedPropertyPath(propertyValue) {
        if (propertyValue) {
        }
        return { isSourceable: false, sources: undefined, type: undefined };
    }
}
SourceUtils.setProductGroupId = SourceUtils.setProductId;
//# sourceMappingURL=SourceUtils.js.map